import React, { useState } from 'react';
import { Slider, styled, TextField, FormControl, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const SliderInputContainer = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '50% 50%',
  alignItems: 'center',
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(3),
}));

interface Props {
  label: string;
  defaultValue: number;
  maxValue: number;
  onChange: (arg0: number) => void;
}

export const InputSlider = ({ label, defaultValue, maxValue, onChange }: Props) => {
  const [value, setValue] = useState<number>(defaultValue);
  const { t } = useTranslation();

  const handleSliderChange = (_event: any, newValue: any) => {
    setValue(newValue);
    onChange(newValue);
  };

  const handleInputChange = (event: any) => {
    try {
      const val = parseInt(event.target.value) > 0 ? parseInt(event.target.value) : 1;
      setValue(val);
      onChange(val);
    } catch (err) {
      setValue(1);
      onChange(1);
    }
  };

  return (
    <>
      <SliderInputContainer>
        <Typography variant="body1" color="textPrimary">
          {label}
        </Typography>
        <div>
          <FormControl fullWidth>
            <TextField
              value={value}
              onChange={handleInputChange}
              data-testid="simple-calculator-invested-amount"
              variant="outlined"
              label={t('cashbackCalculator.simple.amount')}
              inputProps={{
                min: 0,
                type: 'number',
                'aria-labelledby': 'input-slider',
                'data-hj-whitelist': true,
              }}
            />
          </FormControl>
        </div>
      </SliderInputContainer>
      <Slider
        value={value}
        min={0}
        max={maxValue}
        onChange={handleSliderChange}
        onChangeCommitted={handleSliderChange}
        aria-labelledby="input-slider"
      />
    </>
  );
};
